module.exports = __webpack_public_path__ + "img/VN_BBC.b54ae13f.png";